import { render, staticRenderFns } from "./alarm-main.vue?vue&type=template&id=72e6a624&scoped=true"
import script from "./alarm-main.vue?vue&type=script&lang=js"
export * from "./alarm-main.vue?vue&type=script&lang=js"
import style0 from "./alarm-main.vue?vue&type=style&index=0&id=72e6a624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e6a624",
  null
  
)

export default component.exports